import React from 'react';
import styled from 'styled-components';
import { fadeIn } from 'styles/animation';
import hexToRGB from 'utils/hecToRGB';


export const CalendarTitle = styled.h2`
font-weight: 500;
font-size: 14px;
line-height: 17px;
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
max-width: 100%;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
text-align: center;
word-break: break-all;
color: #000000;
margin: 0 16px;
margin-bottom: 6px;
`;

export const SecondaryText = styled.div`
font-size: 12px;
line-height: 14px;
text-align: center;
color: #2F3C4E;
margin: ${p => p.margin ? p.margin : '0 20px 20px'};
opacity: ${p => p.disabled ? 0.2 : 0.4};
${p => p.width && `width: ${p.width};`}
`;

export const CalendarContainer = styled.div`
background-color: ${p => p.theme.palette.blue5};
padding: 30px 0 20px;
border-radius: 20px;
position: relative;
overflow: hidden;
`;

export const CalendarCloseIcon = styled.img`
position: absolute;
right:20px;
top: 20px;
width: 11px;
cursor: pointer;
`;

export const LoadingOverlay = styled.div`
position: absolute;
top: 0;
bottom: 0; 
opacity: 1;
z-index: 150;
background: #ffffff1A;
width: 100%;
cursor: wait;
`;

export const CalendarFieldHeader = styled.h2`
font-weight: 500;
font-size: 12px;
line-height: 14px;
color: #2F3C4E;
margin: 0;
margin-bottom: 10px;
margin-left: 20px;
`;

export const FieldContainer = styled.div`
${p => p.margin && `margin: ${p.margin}`}
position: relative;
`;

export const CalendarListContainer = styled.div`
display: flex;
justify-content: space-between;
padding: 0px 6px;
align-items: center;
`;

export const ArrowContainer = styled.div`
position: relative;
height: ${p => p.height ? p.height : '50px'};
display: flex;
align-items: center;
cursor: pointer;
img {
  z-index: 100;
  position: relative;
}
`;

export const CalendarScrollContainer = styled.div`
width: 100%;
display: flex;
overflow-x: scroll;

-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none;  /* Firefox */
&::-webkit-scrollbar {
  display: none;
}
`;

export const CalendarDate = styled.div`
line-height: 21px;
text-align: center;
border-radius: 10px;
color: ${p => p.active ? '#FFFFFF' : '#2F3C4ECC'};
font-size: ${p => p.active ? '18px' : '16px'};
background: ${p => p.active ? p.headerBackgroundColor || p.theme.palette.blue3 : 'transparent'};
box-shadow: ${p => p.active && `0px 5px 12px rgba(${hexToRGB(p.headerBackgroundColor || p.theme.palette.blue3)}, 0.2)`};
opacity: ${p => p.disabled ? 0.3 : 1};
cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
width: 34px;
border: 1px solid transparent;
padding: 5px 0;
position: absolute;
bottom: 0;
left: 50%;
transform: translateX(-50%);
&:hover {
  ${p => !p.disabled && !p.active && `border: 1px solid ${p.headerBackgroundColor || p.theme.palette.blue3};`}
}
`;

export const CalendarDateItemWrapper = styled.div`
display: flex;
flex-direction: column;
height: 50px;
position: relative;
cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
${p => p.isFirst && `margin-left: 7px;`}
`;

export const FadeToRight = styled.div`
position: absolute;
top: 0;
z-index: 12;
height: ${p => p.height ? p.height : '50px'};
width: 30px;
opacity: 0;
background: linear-gradient(to right,#EBF0F7 0%,#EBF0F700 100%);
animation: ${fadeIn} 0.4s ease-in-out 0.1s forwards;
`;

export const FadeToLeft = styled.div`
position: absolute;
top: 0;
right: 0;
z-index: 12;
height: ${p => p.height ? p.height : '50px'};
width: 30px;
background: linear-gradient(to left,#EBF0F7 0%,#EBF0F700 100%);
animation: ${fadeIn} 0.4s ease-in-out 0.1s forwards;
`;


export const CalendarTimeItemWrapper = styled.div`
display: flex;
align-items: center;
${p => p.isFirst && `margin-left: 7px`}
${p => p.isLast && `padding-right: 10px`}
`;


export const Time = styled.div`
padding: 4px 5px;
font-size: 12px;
line-height: 14px;
text-align: center;
border-radius: 6px;
color: ${p => p.active ? '#FFFFFF' : '#2F3C4ECC'};
background: ${p => p.active ? p.headerBackgroundColor || p.theme.palette.blue3 : 'transparent'};
box-shadow: ${p => p.active && `0px 5px 12px rgba(${hexToRGB(p.headerBackgroundColor || p.theme.palette.blue3)}, 0.2)`};
opacity: ${p => p.disabled ? 0.3 : 1};
cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
border: 1px solid transparent;
&:hover {
  ${p => !p.active && `border: 1px solid ${p.headerBackgroundColor || p.theme.palette.blue3};`}
}
`;

export const DashedLine = styled.div`
width: 10px;
height: 1px;
opacity: 0.2;
margin: 0 3px;
border-bottom: 1px dashed #2F3C4E;
`;

export const CalendarFieldInput = styled.input`

background: #FFFFFF;
mix-blend-mode: normal;
border: 1px solid rgba(109, 114, 120, 0.3);
box-sizing: border-box;
border-radius: 12px;
padding: 10px;
margin: 0 10px;
width: calc(100% - 20px);
outline: none;
font-size: 14px;
line-height: 17px;
color: #2F3C4E;

 &::-webkit-input-placeholder   {
  color: #49546533;
}
`;

export const BookButton = styled.button`
background: ${p => p.backgroundColor || p.theme.palette.blue3};
box-shadow: 0px 5px 10px ${p => p.boxShadowColor ? p.boxShadowColor :  `rgba(${hexToRGB(p.backgroundColor) || hexToRGB(p.theme.palette.blue3)}, 0.2)`};
border-radius: 20px;
border: none;
outline: none;
padding: 16px;
margin: 0 20px;
width: calc(100% - 40px);
color: ${p => p.textColor ? p.textColor : 'white'};
font-weight: 500;
font-size: 14px;
line-height: 17px;
text-align: center;
cursor: pointer;
`;

export const CalendarSuccess = styled.div`
display: flex;
flex-direction: column;
`;

export const SkeletonDateContainer = styled.div`
margin: 0 10px;

div {
  margin-bottom: 10px;
}

`;

export const SkeletonTimeContainer = styled.div`
${p => p.isFirst && `margin-left: 7px`}
${p => p.isLast && `margin-right: 7px`}
display: flex;
align-items: center;

`;



export const ErrorMessage = styled.div`
font-size: 10px;
line-height: 12px;
color: #FF2838;

mix-blend-mode: normal;
opacity: 0.8;
`;

export const ErrorMessageWrapper = styled.div`
margin: ${p => p.margin ? p.margin : '4px 22px 0'};
position: ${p => p.position ? p.position : 'absolute'};
`;

export const FieldContainerHeader = styled.div`
display: flex;
align-items: center;
`;

export const CalendarForm = styled.form`
margin: 0;
`;



export const CalendarClosed = styled.div`
background: #EDF0F7;
border: 1px solid  ${p => p.headerBackgroundColor || p.theme.palette.blue3};
border-radius: 5px;
padding: 7px;
align-items: center;
display: inline-flex;
cursor: pointer;
margin: ${p => p.margin};
`;

export const CalendarIconContainer = styled.div`
background:  ${p => p.headerBackgroundColor || p.theme.palette.blue3};
border-radius: 5px;
padding: 5px;
margin-right: 10px;

img {
width: 16px;
}
`;

export const CalendarCloseText = styled.p`
padding: 0;
margin: 0;
font-size: 14px;
line-height: 17px;
/* identical to box height */
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
max-width: 100%;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
word-break: break-all;
/* font color */

color: #353B47;
opacity: 0.8;
`;


export const CalendarMessageContainer = styled.div`

`;

export const CalendarInfoContainer = styled.div`
display: flex;
margin-left: 6px;
align-items: center;
`;

export const CalendarActionContainer = styled.div`

`;


export const SenderImageWrapper = styled.div`
opacity: 1;
margin: ${p => p.margin};
`;

export const MessageElementWrapper = styled(({ lead, isCalendarLeftSpace, messageType, children, ...others }) => (
<div {...others}>{children}</div>
))`
// float: ${p => (p.lead ? 'right' : 'left')};
margin: 0;
margin-left: ${p => p.isCalendarLeftSpace ? '40px' : '10px'};
width: 100%;
`;


export const NoSlotsWindow = styled.div`
  position: relative;
  padding-top: 33px;
  display: flex;
  flex-direction: column;

  img {
    margin-bottom: 20px;
  }
`;
